module.exports = __webpack_public_path__ + "static/media/lock_icon.6ac09183.svg";